import apiService from "./apiServices";
import axios from 'axios';

export const createLeadServices = async (formData, token) => {
  try {
    const response = await apiService('/lead/save', 'POST', formData, null, token);
    return response;
  } catch (error) {
    // throw (error?.message || 'Creating lead is failed. Please try again.');
     throw error.response.data;
  }
};

export const updateLeadService = async (formData, token) => {
  try {
    const response = await apiService('/lead/update', 'PUT', formData, null, token);
    return response;
  } catch (error) {
    // throw (error?.message || 'Updating lead is failed. Please try again.');
    throw error.response.data;
  }
};

export const getAllLeads = async (page, size, token) => {
  try {
    const response = await apiService(`/lead/get/all?page=${page}&size=${size}&sort=id,desc`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw (error?.message || 'Get All Leads service failed. Please try again.');
  }
};

export const getLeadsById = async (id, token) => {
  try {
    const response = await apiService(`/notes/lead/${id}`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw (error?.message || 'Get  Leads By Id service failed. Please try again.');
  }
};

export const getDeletedLeadServices = async (id, token) => {
  try {
    const response = await apiService(`/lead/delete/${id}`, 'DELETE', null, null, token);
    return response;
  } catch (error) {
    throw (error?.message || 'Delete service is failed. Please try again.');
  }
};

export const getDeleteNoteServices = async (noteid, token) => {
  try {
    const response = await apiService(`/notes/${noteid}`, 'DELETE', null, null, token);
    return response;
  } catch (error) {
    throw (error?.message || 'Delete service is failed. Please try again.');
  }
};

export const searchLeadServices = async (formData,page,size, token) => {
  try {
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    // const payload = {
    //   assignedTo: formData.assignedAgent,
    //   quoteStatus: formData.quoteStatus,
    //   leadSource: formData.leadSource,
    //   status: formData.leadStatus,
    //   email: formData.email,
    //   phone: formData.phone,
    //   lineOfBusiness: formData.lineOfBusiness,
    //   createdDate: formData.createdDate?.format('MM-DD-YYYY'),
    //   lastModifiedDate: formData.lastModifiedDate?.format('MM-DD-YYYY'),
    // };

    const res = await axios.post(
      `https://crmapi-dev.autoairater.com/api/v1/lead/search?page=${page}&size=${size}`,
      formData,
      { headers }
    );

    // return res?.data?.content || [];
    // console.log("res",res)
    // return res;
     return res?.data;
  } catch (error) {
    throw (error?.message || 'Search lead failed. Please try again.');
  }
};

export const searchLeadReportServices = async (
  formData,
  token,
  page,
  size,
  sortField = "",
  sortOrder = "asc"
) => {
  try {
    let url = `/reports/lead/search?page=${page}&size=${size}`;
    if (sortField) {
      url += `&sort=${sortField},${sortOrder}`;
    }
    const response = await apiService(url, 'POST', formData, null, token);
    return response;
  } catch (error) {
    throw (error?.message || 'service is failed. Please try again.');
  }
};